import { Request } from 'commons/utils/request'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useClientPortalReportContext } from '../../context/reportContext'

export const Actions = () => {
  const {
    data: {
      form: { relationshipId, status }
    }
  } = useClientPortalReportContext()

  return (
    <ExportCSVButton
      reportName="Client Portal"
      url={Request.urls.bank.portalReportCompaniesCSV}
      parametersForm={{
        relationshipId,
        status
      }}
    />
  )
}
